import { SPARTAN_ENGINE_SPEC_LABELS_WITH_UNITS } from '@/app/lcv/components/sections/spartan/shared/engine-spec/constants';

/** Design reference width for parallax scene layers (mountain, rock, car). */
export const SPARTAN_PRODUCT_HERO_BANNER_SCENE_REF_WIDTH = 1672;

/** Design reference width for parallax scene layers at 3xl (1920px). */
export const SPARTAN_PRODUCT_HERO_BANNER_SCENE_REF_WIDTH_3XL = 1920;

/** Design reference height for parallax scene sizing. */
export const SPARTAN_PRODUCT_HERO_BANNER_SCENE_REF_HEIGHT = 1176;

export const SPARTAN_PRODUCT_HERO_MOBILE_COMPOSITION_MEDIA =
  '(max-width: 1032px) and (orientation: portrait)';

export const SPARTAN_PRODUCT_HERO_DESKTOP_COMPOSITION_MEDIA =
  '(min-width: 1033px), (orientation: landscape)';

export const SPARTAN_PRODUCT_HERO_DESKTOP_IMAGE_WIDTHS = [
  640, 750, 828, 1080, 1280, 1440, 1680, 1920, 2048, 2560, 2880, 3360,
] as const;

/** Portrait background candidates capped near 2x density, including 1032px tablets. */
export const SPARTAN_PRODUCT_HERO_MOBILE_DPR_2_BACKGROUND_IMAGE_WIDTHS = [
  640, 750, 828, 1080, 1280, 1680, 2048,
] as const;

/** Oversized phone scene-layer candidates capped near 2x density. */
export const SPARTAN_PRODUCT_HERO_MOBILE_DPR_2_LAYER_IMAGE_WIDTHS = [
  640, 750, 828, 1080, 1280,
] as const;

/** Desktop-only camera drift applied to the complete layered hero composition. */
export const SPARTAN_PRODUCT_HERO_BANNER_SCENE_SCROLL_SPEED = {
  mobile: '0',
  desktop: '-0.15',
} as const;

/** Default duration for the engine-logo stretch reveal within the hero timeline. */
export const SPARTAN_PRODUCT_HERO_BANNER_ENGINE_LOGO_STRETCH_DURATION_MS = 960;

export const SPARTAN_PRODUCT_HERO_BANNER_SPEC_LABELS = {
  ...SPARTAN_ENGINE_SPEC_LABELS_WITH_UNITS,
  startPrice: 'ราคาเริ่มต้น (THB)',
} as const;

/** Shared spec labels in display order (excludes start price). */
export const SPARTAN_PRODUCT_HERO_BANNER_SPEC_LABEL_LIST = [
  SPARTAN_PRODUCT_HERO_BANNER_SPEC_LABELS.horsepower,
  SPARTAN_PRODUCT_HERO_BANNER_SPEC_LABELS.torque,
] as const;
